// extracted by mini-css-extract-plugin
export default {"background":"_2J4l2","number":"_210Fm","numberBorder":"_3-hmS","skeleton":"_3ZPRY","ticket":"_1y2_6"};